import { trendingRank } from "@/mocks/feed";

export default function Trending() {
  return (
    <section id="hot" className="py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-1 flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-fire-fill"></i> 实时更新
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">今日热榜</h2>
            <p className="mt-2 text-sm text-foreground-600">现在最值得蹲的瓜都在这里，点进去跟着围观不落单。</p>
          </div>
          <a
            href="#board"
            className="group inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-700 hover:text-primary-800"
          >
            围观广场入口 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-4 lg:grid-cols-2 lg:gap-5">
          {trendingRank.map((item) => (
            <a
              key={item.id}
              href={`#board`}
              className="group flex items-center gap-4 rounded-xl border border-background-200 bg-background-100/60 p-4 transition-colors hover:border-primary-200 hover:bg-background-50 md:p-5"
            >
              <div
                className={`flex h-11 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-lg font-bold md:h-12 md:w-10 ${
                  item.rank <= 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-200 text-secondary-800"
                }`}
              >
                {item.rank}
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700 md:text-base">
                    {item.title}
                  </h3>
                  {item.trend === "new" && (
                    <span className="chip shrink-0 bg-accent-100 px-2 text-[10px] text-accent-800">新</span>
                  )}
                  {item.trend === "hot" && (
                    <span className="chip shrink-0 bg-primary-100 px-2 text-[10px] text-primary-800">热</span>
                  )}
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{item.category}</span>
                  <span className="mx-2 text-foreground-300">|</span>
                  <span className="whitespace-nowrap">围观 {(item.heat / 10000).toFixed(1)}W</span>
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-600"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}